import { Button, Form, Input, message, Modal, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { calculateColumnsWidth } from 'api/common';
import {
  AgentReceiptListData,
  AgentReceiptPagedList,
  ConfirmRejectPayload,
  getAgentReceiptList,
  getConfirmRejectStatus,
  ReceiptPayload,
} from 'api/receipt';
import { LoadingScreen } from 'common/components';
import moment from 'moment';
import { useEffect, useState } from 'react';
//import { useNavigate } from 'react-router-dom';
//import Table, { ColumnsType } from "antd/lib/table";

type Props = {
  filter: ReceiptPayload;
  setOnlyDigitError: (error: boolean) => void;
};
const AgentReceiptList = ({ filter, setOnlyDigitError }: Props) => {
  let payPagedList: AgentReceiptPagedList = {
    ConfirmRejectStatus: '',
    data: {
      currentPageIndex: 1,
      noOfRecords: 0,
      data: [],
    },
  };
  const [form] = Form.useForm<ReceiptPayload>();
  //const navigate = useNavigate();
  const [pagedList, setPagedList] = useState(payPagedList);
  const [isLoading, setIsLoading] = useState(false);
  const [isClear, setisClear] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [requestSelected, setRequestSelected] = useState(0);
  const isAdmin = sessionStorage.getItem('isAdmin');

  filter.Username = sessionStorage.getItem('user')?.toString();
  if (isAdmin != 'true') {
    filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
  }
  //filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();

  useEffect(() => {
    setIsLoading(false);
    filter.PageNo = 1;
    filter.PageSize = 10;
    // console.log('Filter before sending request to server :-', filter);

    getAgentReceiptList(filter).then((res) => {
      setPagedList(res);
      setOnlyDigitError(false);
      setIsLoading(true);

      //message.success('Success');
    });
  }, [filter]);

  function handleConfirm(_e: any) {
    debugger;
    let confirmRejectStatus: ConfirmRejectPayload = {
      paymentRequestId: _e,
      status: 'Confirm',
      agentRejectRemarks: '',
    };

    getConfirmRejectStatus(confirmRejectStatus)
      .then((x) => {
        if (x.responseCode == '200') {
          message.success('Successfully Done!');
        } else {
          message.error('Something Went Wrong');
        }
      })
      .finally(() => {
        form.resetFields();
        window.location.reload();
        //navigate('/receipt/receipt-dashboard');
      });
  }

  function handleReject(_e: any) {
    debugger;
    setIsModalOpen(true);
    setRequestSelected(_e);
  }

  const handleOk = () => {
    let confirmRejectStatus: ConfirmRejectPayload = {
      paymentRequestId: requestSelected,
      status: 'Reject',
      agentRejectRemarks: isClear,
    };
    getConfirmRejectStatus(confirmRejectStatus)
      .then((x) => {
        if (x.responseCode == '200') {
          message.success('Successfully Done!');
        } else {
          message.error('Something Went Wrong');
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setisClear('');
        setRequestSelected(0);
        setIsModalOpen(false);
        window.location.reload();
      });
  };

  const handleClose = () => {
    setisClear('');
    setIsModalOpen(false);
  };

  const handleClear = () => {
    setisClear('');
  };
  const handleUserInput = (e: any) => {
    setisClear(e.target.value);
  };

  // const filteredData = pagedList.data.data.filter(
  //   (item) => item.ConfirmRejectStatus !== 'Rejected' && item.ConfirmRejectStatus !== 'Confirmed'
  // );

  // console.log('filterd data in agent REcipt list', filteredData);

  const columns: ColumnsType<AgentReceiptListData> = [
    {
      key: 'PaymentRequestId',
      title: 'Payment Request ID',
      dataIndex: 'PaymentRequestId',
      fixed: 'left',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
      className: '',
    },
    {
      key: 'LANumber',
      title: 'Loan Number',
      dataIndex: 'LANumber',
      fixed: 'left',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'LoanType',
      title: 'Loan Type',
      dataIndex: 'LoanType',
      fixed: 'left',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'SourceApplicationName',
      title: 'Source Application Name',
      dataIndex: 'SourceApplicationName',
      width: 250,
    },
    {
      key: 'Mode',
      title: 'Mode',
      dataIndex: 'Mode',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'PaymentPurpose',
      title: 'Payment Purpose',
      dataIndex: 'PaymentPurpose',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),

      // onFilter: (value: any, record: { PAYMENTPURPOSE: string | any[] }) =>
      //   record.PAYMENTPURPOSE.indexOf(value) === 0,
    },
    {
      key: 'Amount',
      title: 'Amount',
      dataIndex: 'Amount',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'RequestStatus',
      title: 'Request Status',
      dataIndex: 'RequestStatus',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
      // onFilter: (value: any, record: { RequestStatus: string | any[] }) =>
      //   record.RequestStatus.indexOf(value) === 0,
    },
    {
      key: 'paymentRef',
      title: 'PaymentRef',
      dataIndex: 'paymentRef',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'RefTransaction',
      title: 'Ref Transaction',
      dataIndex: 'RefTransaction',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },

    {
      key: 'FundingAccount',
      title: 'Funding Account',
      dataIndex: 'FundingAccount',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'bankCode',
      title: 'Bank Code',
      dataIndex: 'bankCode',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'Currency',
      title: 'Currency',
      dataIndex: 'Currency',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'FavourName',
      title: 'Favour Name',
      dataIndex: 'FavourName',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'PaymentRequestDateTime',
      title: 'Request Date',
      dataIndex: 'PaymentRequestDateTime',
      ellipsis: true,
      // render: (record) => (
      //   <Tooltip placement="topLeft" title={record}>
      //     {record}
      //   </Tooltip>
      // ),
      className: '',
      render: (date: string) => getFullDate(date),
    },
    {
      key: 'ByAgent',
      title: 'By Agent',
      dataIndex: 'ByAgent',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'verificationReason',
      title: 'Verification Reason',
      dataIndex: 'verificationReason',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'confirmRejectStatus',
      title: 'Status',
      dataIndex: 'confirmRejectStatus',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'remarks',
      title: 'Remark',
      dataIndex: 'remarks',
      width: 250,
    },
    {
      key: 'Action',
      title: 'Action',
      dataIndex: 'Action',
      render: (_text, record) => (
        <>
          {!['rejected', 'confirmed'].includes(record.confirmRejectStatus?.toLowerCase()) && (
            <>
              <button
                className="btn btn-primary btn-sm prime-button"
                onClick={() => handleConfirm(record.PaymentRequestId)}
              >
                Confirm
              </button>
              &nbsp; &nbsp;
              <button
                className="btn btn-primary btn-sm prime-button"
                onClick={() => handleReject(record.PaymentRequestId)}
              >
                Reject
              </button>
            </>
          )}
        </>
      ),
    },
  ];

  function getFullDate(date: string) {
    let dateMoment = moment(new Date(date)).format('DD/MM/YYYY HH:mm:ss');
    return dateMoment;
  }

  let payfilter: ReceiptPayload = {};
  if (!pagedList || !isLoading) {
    return <LoadingScreen />;
  }

  const handleChange = (_pagination: any, filters: any, sorter: any) => {
    // console.log('Filters', filters);
    setIsLoading(false);

    if (sorter.hasOwnProperty('column')) {
      // params.order = { field: sorter.field, dir: sorter.order };
    }
    filter.Username = sessionStorage.getItem('user')?.toString();
    // filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
    payfilter = filter;
    payfilter.IsDedupe = filter.IsDedupe;
    payfilter.ConfirmRejectStatus = filter.ConfirmRejectStatus;
    payfilter.PageNo = _pagination.current;
    payfilter.PageSize = _pagination.pageSize;
    payfilter.LoanNumber = filters.LoanNumber?.toString();
    payfilter.paymentRequestId = filters.paymentRequestId?.toString();
    payfilter.PaymentPurpose = filter.PaymentPurpose?.toString();
    payfilter.requestDateFrom = filters.requestDateFrom?.toString();
    payfilter.to = filters.to?.toString();
    // console.log('payfilter request before sending request to server ', payfilter);

    getAgentReceiptList(payfilter).then((res) => {
      setPagedList(res);
      setIsLoading(true);
    });
  };

  const maxWidthPerCell = 600;
  // console.log("page list" , page);

  const dataTable = calculateColumnsWidth(columns, pagedList.data.data, maxWidthPerCell);
  const tableHeight = 500;
  const rowKey = 'ROWNUM';
  return (
    <>
      <Table
        dataSource={dataTable.source}
        columns={dataTable.columns}
        rowKey={rowKey}
        pagination={{
          pageSize: 10,
          total: pagedList.data.noOfRecords,
          current: pagedList.data.currentPageIndex == 0 ? 1 : pagedList.data.currentPageIndex,
        }}
        scroll={{ x: dataTable.tableWidth, y: tableHeight }}
        className="table table-striped "
        onChange={handleChange}
      />
      <Modal
        title="Agent Reject Remarks"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleClose}
        width="50%"
        footer={[<div></div>]}
      >
        <div className="input-box">
          <Input onChange={handleUserInput} value={isClear} />
        </div>
        <></>
        <Button
          className="proceed-btn"
          id="btnSubmit"
          htmlType="submit"
          size="small"
          style={{ width: '15%', marginLeft: '20%' }}
          onClick={handleOk}
        >
          OK
        </Button>
        <Button
          className="proceed-btn"
          id="btnSubmit"
          htmlType="submit"
          size="small"
          style={{ width: '15%', marginLeft: '5%' }}
          onClick={handleClear}
        >
          CLEAR
        </Button>
        <Button
          className="proceed-btn"
          id="btnSubmit"
          htmlType="submit"
          size="small"
          style={{ width: '15%', marginLeft: '5%' }}
          onClick={handleClose}
        >
          CLOSE
        </Button>
      </Modal>
    </>
  );
};

export default AgentReceiptList;
